import React, { useState, useEffect } from 'react';
import { Link, useLocation } from 'react-router-dom';
import { X, Sparkles, Maximize2 } from 'lucide-react';
import ChatPanel from './chat/ChatPanel';
import api from '../lib/api';

const HIDDEN_PREFIXES = ['/dashboard', '/ask'];

const ChatWidget = () => {
  const [open, setOpen] = useState(false);
  const [enabled, setEnabled] = useState(false);
  const { pathname } = useLocation();

  useEffect(() => {
    api.get('/chat/config').then((r) => setEnabled(!!r.data?.enabled)).catch(() => setEnabled(false));
  }, []);

  if (!enabled) return null;
  if (HIDDEN_PREFIXES.some((p) => pathname.startsWith(p))) return null;

  return (
    <>
      {/* Floating button */}
      {!open && (
        <button
          onClick={() => setOpen(true)}
          data-testid="chat-widget-button"
          aria-label="Ask the Seeker's Guide"
          className="fixed bottom-5 right-5 z-[60] flex items-center gap-2 rounded-full bg-mahogany text-cream pl-4 pr-5 py-3 shadow-xl hover:bg-burgundy transition-all hover:scale-105"
        >
          <Sparkles className="w-5 h-5" />
          <span className="font-medium text-sm hidden sm:inline">Ask the Guide</span>
        </button>
      )}

      {/* Panel */}
      {open && (
        <div className="fixed bottom-5 right-5 z-[60] w-[calc(100vw-2.5rem)] sm:w-[400px] h-[70vh] max-h-[620px] bg-cream rounded-3xl shadow-2xl border border-rose/40 flex flex-col overflow-hidden" data-testid="chat-widget-panel">
          <div className="flex items-center justify-between px-4 py-3 bg-mahogany text-cream">
            <div className="flex items-center gap-2">
              <Sparkles className="w-4 h-4" />
              <span className="font-serif-display text-lg">Seeker's Guide</span>
            </div>
            <div className="flex items-center gap-1">
              <Link to="/ask" onClick={() => setOpen(false)} title="Open full page" data-testid="chat-widget-expand" className="p-1.5 hover:bg-white/15 rounded-lg">
                <Maximize2 className="w-4 h-4" />
              </Link>
              <button onClick={() => setOpen(false)} title="Close" data-testid="chat-widget-close" className="p-1.5 hover:bg-white/15 rounded-lg">
                <X className="w-4 h-4" />
              </button>
            </div>
          </div>
          <div className="flex-1 min-h-0">
            <ChatPanel variant="widget" />
          </div>
        </div>
      )}
    </>
  );
};

export default ChatWidget;
